class SearchLocationAutocomplete {
    constructor() {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        this.csrfToken = csrfToken;
    }

    async search(place) {
        if (place.length < 3) {
            return []
        }
        const response = await fetch(`/locations?search=${place}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            }
        })

        const data = await response.json()

        if (data.length === 0) {
            return [];
        }

        if (data.results.length === 0) {
            return [];
        }

        return data;
    }

    async details(placeId) {
        const response = await fetch(`/locations/${placeId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            }
        })

        const info = await response.json()

        return info
    }
}

export default SearchLocationAutocomplete;
